import React from "react";

const MinimiseBigVideo = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3639 2.05018C13.7545 1.65966 13.7555 1.02548 13.3662 0.633717C12.9769 0.241951 12.3447 0.240946 11.9542 0.631472L6.99996 5.58573L2.0503 0.636073C1.65978 0.245547 1.02561 0.244539 0.633839 0.633821C0.242073 1.0231 0.241068 1.65526 0.631594 2.04579L5.58574 6.99994L0.636012 11.9497C0.245486 12.3402 0.244478 12.9744 0.633759 13.3661C1.02304 13.7579 1.6552 13.7589 2.04573 13.3684L6.99996 8.41415L11.9498 13.364C12.3403 13.7545 12.9745 13.7555 13.3663 13.3662C13.758 12.977 13.759 12.3448 13.3685 11.9543L8.41417 6.99994L13.3639 2.05018Z"
        fill="white"
      />
    </svg>
  );
};

export default MinimiseBigVideo;
